import { RequestBuilder } from "../requestBuilder";
import {
  ChatToolActionsParamsSchema,
  ChatToolActionsResponseSchema,
  ConfirmToolActionInputSchema,
  ConfirmToolActionParamsSchema,
  ConfirmToolActionResponseSchema,
  ToolApprovalPrefsResponseSchema,
  ToolConnectivityResponseSchema,
  UpdateToolApprovalPrefsInputSchema,
} from "./toolsClient.types";

// GET /tool-connectivity - Per-integration connection status for the current project
export const ToolConnectivityRequestConfig = new RequestBuilder({
  path: () => "/tool-connectivity",
  responseSchema: ToolConnectivityResponseSchema,
}).withIncludeProjectId();

// GET /tool-approval-prefs - User's tool auto-approve preferences (user-scoped)
export const ToolApprovalPrefsRequestConfig = new RequestBuilder({
  path: () => "/tool-approval-prefs",
  responseSchema: ToolApprovalPrefsResponseSchema,
});

// PUT /tool-approval-prefs - Replace the user's tool auto-approve preferences
export const UpdateToolApprovalPrefsRequestConfig = new RequestBuilder({
  path: () => "/tool-approval-prefs",
  bodySchema: UpdateToolApprovalPrefsInputSchema,
}).withMethod("PUT");

// GET /tool-actions?chat={chatId} - Statuses of a chat's tool actions
export const ChatToolActionsRequestConfig = new RequestBuilder({
  paramsSchema: ChatToolActionsParamsSchema,
  path: () => "/tool-actions",
  responseSchema: ChatToolActionsResponseSchema,
})
  .withQueryParams((params) => ({ chat: params.chat }))
  .withIncludeProjectId();

// POST /tool-actions/{actionId}/confirm - Approve or reject a pending tool action
export const ConfirmToolActionRequestConfig = new RequestBuilder({
  paramsSchema: ConfirmToolActionParamsSchema,
  path: (params) => `/tool-actions/${params.actionId}/confirm`,
  bodySchema: ConfirmToolActionInputSchema,
  responseSchema: ConfirmToolActionResponseSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();
